

import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Select, MenuItem, Button, Collapse} from "@mui/material";
import {
  getCountryAssetMasterDataList,
  getFamilyAssetMasterDataList,
  getProjectByRegionId,
  getRegionByCountryId,
} from "../../api/Services/masterServie";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage, Loader } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { createFaultData, getPrevFaultByUserIdData, getUniqueAssetNamesByFamilyId } from "../../api/Services/assetServices";

import { assetFamilyMaster, assetType, CountryMaster, ProjectMaster, RegionMaster } from "../../types/assetTypes";
import { IconButton, List, ListItem } from "@mui/material";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
} from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";
import { faultTypes } from "../../types/faultTypes";
import dayjs from "dayjs";
import { useRef } from "react";
import Logo from "../../assets/companyLogo.png";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import ChooseCam from "@mui/icons-material/Camera";
import "react-html5-camera-photo/build/css/index.css";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import { base64ToFile } from "../../const/const";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { uploadFiles } from "../../api/Services/assetServices";
import { RootState } from "../../store/Reduxstore";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate } from "react-router-dom"; // Import navigate
import { Height } from "@mui/icons-material";
interface CreateFaultProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
 // setPathname: React.Dispatch<React.SetStateAction<string>>;
  faultId: number | null;
  setFaultId: React.Dispatch<React.SetStateAction<number | null>>;
  selectedValue: number | null;
  getListOfSelectedProducts: () => void;
}


//import { assetType } from "../../types/assetTypes";

const CreateFault: React.FC = () => {
const userDetails = useSelector((state: RootState) => state.auth)
  console.log(userDetails);
const [formData, setFormData] = useState<faultTypes>({

  faultId: 0,
  user_id: userDetails.userId ?? 0,
  userId: userDetails.userId ?? 0,
  name: "",
  familyAssetId: 0,
  fixed_user_ids: [],  
  fixedAttachments: [],
  familyName: "",
  assetName: "",
  currentLocationId: 0,
  countryName: "",
  hourMeter: 0,
  fault: "",
  worksite: "",
  date: "",
  fixedDate: "",
  attachments: [],
  fixed_user_id: 0, // Default to 0 instead of null
  partsUsed: "",
  workCarriedOut: "",
  faultStatus: "",
  fixedUserName: "",
   regionId: 0,
    projectId: 0,
    projectName: "",
    regionName: "",
    categoryId: 0,
    categoryName: "",
    hoursSpent: 0,  

});

const handleReset = () => {
  setFormData({
    faultId: 0,
    user_id:  userDetails.userId ?? 0,
    userId: userDetails.userId ?? 0,  // Keeping the logged-in user's ID
    name: "",
    familyAssetId: 0,
    familyName: "",
    assetName: "",
    currentLocationId: 0,
    countryName: "",
    hourMeter: 0,
    regionId: 0,
    projectId: 0,
    projectName: "",
    fixed_user_ids: [],  
    fixedAttachments: [],
    regionName: "",
    fault: "",
    worksite: "",
    date: "",
    attachments: [],
    fixed_user_id: 0,
    partsUsed: "",
    workCarriedOut: "",
    faultStatus: "",
    fixedUserName: "", 
    categoryId: 0,
    categoryName: "",
    hoursSpent: 0,
    fixedDate: "",
      
    
  });
  
  
};

  const [region, setRegions] = useState<
     { label: string; value: number }[]
    >([{label: "Select a region", value: 0 }]);
  
    
  
  const [project, setProjects] = useState<
    { label: string; value: string | number }[]
    >([]);
  

useEffect(() => {
  fetchFaultData(); // Call the async function
}, []); 
const fetchFaultData = async () => {
  dispatch(setLoading)
  try {
      const response = await getPrevFaultByUserIdData(userDetails.userId ?? 0); // Pass user_id statically as 1
      // Check if the response is valid and contains data
      if (response && response.data) {
          const faultData = response.data; // Get the fault data directly
          console.log("data:", faultData.assetName);
        if (faultData.currentLocationId) {
          await getRegionList(faultData.currentLocationId);
        }

        // Call getProjectList if rprformegionId exists
        if (faultData.regionId) {
          await getProjectList(faultData.regionId);
        }
          if (faultData) {
            setFormData(faultData);
            await getAssetNameList(faultData.familyAssetId);
          }
      }
  } catch (error:any) {
      console.error("Error fetching fault data:", error); // Handle the error
      CustomMessage(error?.message,'error',enqueueSnackbar);
  } finally{
    dispatch(setLoading(false));
  }
};
  const dispatch = useDispatch(); 
  const [expanded, setExpanded] = useState(false);

  const navigate = useNavigate(); // Initialize navigation
  
  const [countryName, setCurrentLocation] = useState<
      { label: string; value: number }[]
    >([]);

  useEffect(() => {
      if (countryName.length === 0) getCurrentLocationList(1,PAGESEND);
    }, [countryName]);

  const getCurrentLocationList = async (page: number, rows: number) => {
    
      try {
        const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.currentLocationId,
            label: val.countryName,
          }));
          // updatedData.unshift({ label: "--Select--", value: 0 });
          setCurrentLocation(updatedData);
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      }
    };

    const [familyAssetName, setFamilyAssetName] = useState<{ value: number; label: string }[]>([]);
    const [assetType, setAssetTypeList] = useState<{ value: number; label: string }[]>([]);
    const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);
    
    useEffect(() => {
        if (familyAssetName.length === 0) getAssetTypeList(1,PAGESEND);
      }, [familyAssetName]);

    const getAssetTypeList = async (page: number, rows: number) => {
     
      console.log("Fetching asset types...");
    
      try {
        const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
          familyAssetId: { value: "", matchMode: "startsWith" }
        });
    
        console.log("Asset type response:", data, status);
    
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.familyAssetId,
            label: val.familyName,
          }));
   
          setAssetTypeList(updatedData);
          console.log("Updated asset type list:", updatedData);

          setFamilyAssetName(updatedData);
    
        }
      } catch (error: any) {
        console.error("Error fetching asset types:", error);
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } 
    };

const getAssetNameList = async (familyAssetId: number | null | undefined) => {
  if (!familyAssetId) {
    console.warn("Invalid familyAssetId:", familyAssetId);
    return;
  }
  console.log("Fetching asset names for familyAssetId:", familyAssetId);
  try {
    const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
    if (status?.code === 200 && Array.isArray(data) && data.length > 0) {
      const updatedData: { label: string; value: string }[] = data.map((assetName: string) => ({
        value: assetName,
        label: assetName,
      }));
      setAssetNameList(updatedData);
    } else {
      console.log("No asset names found or status is not 200");
    }
  } catch (error: any) {
    console.error("Error fetching asset names:", error);
    CustomMessage(error?.message || "Error fetching asset names", "error", enqueueSnackbar);
  }
};

  const getRegionList = async (currentLocationId: number) => {
    
    try {
        const { data, status } = await getRegionByCountryId(currentLocationId);

        if (status.code === 200 && data?.regions?.length > 0) {
            const updatedData: { label: string; value: number }[] = data.regions.map(
                (val: { regionId: number; regionName: string }) => ({
                    value: val.regionId, // Convert to string
                    label: val.regionName ?? "", // Ensure it's a string
                })
            );
            // updatedData.unshift({ label: "--Select--", value: 0 });
            setRegions(updatedData);
        }  else {
                   // ✅ Set to empty array when no data or non-200 status
                      setRegions([]);
                      setFormData((prev) => ({
                    ...prev,
                    // projectId: "",
                    regionName: ""
                    }));
                    // setProjects([]);
                    // setFormData((prev) => ({
                    //   ...prev,
                    //   // projectId: "",
                    //   projectName: ""
                    // }));
                    }

                         
                     } catch (error: any) {
                      setRegions([]);
                            setFormData((prev) => ({
                          ...prev,
                          // projectId: "",
                          regionName: ""
                        }));
                        // setProjects([]);
                        // setFormData((prev) => ({
                        //   ...prev,
                        //   // projectId: "",
                        //   projectName: ""
                        // }));
                         CustomMessage(error?.message, "error", enqueueSnackbar);
                     } 
    
  }; 
  
  const getProjectList = async (regionId: number) => {
   
    try {
      const { data, status } = await getProjectByRegionId(regionId);
  
      if (status.code === 200 && data.projects.length > 0) {
        const updatedData = data.projects.map((val) => ({
          value: val.projectId.toString(),
          label: val.projectName,
        }));
        // updatedData.unshift({ label: "--Select--", value: "" });
        setProjects(updatedData);
      }
       else if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length === 0) {
      setProjects([{ label: "Select Project", value: ""}]);
    } 
    // ✅ Handle unexpected structure
    else {
      setProjects([{ label: "Select Project", value: "" }]);
      setFormData((prev) => ({
        ...prev,
        // projectId: "",
        projectName: ""
      }));
    }
        
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } 
  };

   const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const fileList = event.target.files;
      if (!fileList || fileList.length === 0) {
          CustomMessage("No file selected", 'error', enqueueSnackbar);
          return;
      }
      const fileArray = Array.from(fileList); // Convert FileList to an array
  
      dispatch(setLoading(true)); // Set loading before upload starts
  
      try {
          const uploadPromises = fileArray.map(async (file) => {
              if (!file){
                CustomMessage("file not found",'error',enqueueSnackbar);
                return;
              };
              const data = new FormData();
              data.append('file', file); // Ensure the key matches backend expectations       
  
              const response = await uploadFiles(data);
              if (response.status.code === 201) {
                // Update formData with the uploaded files
                setFormData((prev) => ({
                  ...prev,
                  attachments: Array.isArray(prev.attachments)
                    ? [...prev.attachments, { ...response.data }]
                    : [{ ...response.data }]
                }));
                return response.data;
              } else {
                CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
                throw new Error(`Upload failed with status: ${response.status.code}`);
              }
          });
  
          const uploadedFiles = await Promise.all(uploadPromises); // Wait for all uploads to complete
          CustomMessage("All files uploaded successfully", 'success', enqueueSnackbar);
  
      } catch (error: any) {
        CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
      } finally {
        dispatch(setLoading(false)); // Set loading to false after all uploads finish
      }
    };

  const handleSubmit = async (e: any) => {
    e?.preventDefault();  
    const updatedData = { ...formData };
    if (updatedData.date) {
      updatedData.date = dayjs(updatedData.date).format("YYYY-MM-DD");
    }

    if (!updatedData.date) {
      CustomMessage("Please select a date.", "error", enqueueSnackbar);
      return;
    }
    const idFields = ["familyAssetId", "currentLocationId"];
      idFields.forEach((key) => {
        if (
          updatedData[key as keyof typeof updatedData] === 0 ||
          updatedData[key as keyof typeof updatedData] === undefined
        ) {
          updatedData[key as keyof typeof updatedData] = null;
        }
      });

    updatedData.user_id = userDetails.userId ?? 0; // Default to 0 if undefined
    const payload = {
      faultId: 0,
      assetName: updatedData.assetName,
      familyName: updatedData.familyName,
      familyAssetId: updatedData.familyAssetId,
      countryName: updatedData.currentLocation,
      userName: updatedData.userName,
      currentLocationId: updatedData.currentLocationId,
      hourMeter: isNaN(Number(updatedData.hourMeter)) ? 0 : Number(updatedData.hourMeter),
      fault: updatedData.fault,
      worksite: updatedData.worksite,
      date: updatedData.date,
      user_id: updatedData.user_id,
      userId: updatedData.user_id,
      regionId: updatedData.regionId,
      projectId: updatedData.projectId,
      regionName: updatedData.regionName,
      projectName: updatedData.projectName,
      name: updatedData.name,
      attachments: updatedData.attachments,
      fixed_user_id: updatedData.fixed_user_id ?? null,  // Default to 0 if undefined
      partsUsed: updatedData.partsUsed || "",         // Default to empty string if undefined
      workCarriedOut: updatedData.workCarriedOut || "", // Default to empty string if undefined
      faultStatus: updatedData.faultStatus || "",
      fixedUserName: updatedData.fixedUserName || "",
      fixed_user_ids: updatedData.fixed_user_ids || [], 
      categoryId: updatedData.categoryId  || 0,
      categoryName: updatedData.categoryName || "",
      hoursSpent: updatedData.hoursSpent || 0, 
      fixedAttachments: [],
      fixedDate: "",
    
        
  };
  
    dispatch(setLoading(true));
  
    try {
      // Always use createFaultData
      const response = await createFaultData(payload);

      console.log("Response:", response); // Debugging
      console.log("Response Status:", response.status); // Debugging

  
      // Check response status directly if it's a number
      if (response.status.code === 201 || response.status.code === 200) {
        CustomMessage(
                  response.status.message,
                  "success",
                  enqueueSnackbar
                );
        
      } else {
        CustomMessage(response.status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  
  const handleSelectAssetTypeChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof assetFamilyMaster,
    name2: keyof assetFamilyMaster
  ) => {
    const updatedData: Partial<faultTypes> = { ...formData }; // Ensure all required fields are included
  
    updatedData[name] = (e.target as { value: { label: string } }).value?.label || "";
    updatedData[name2] = (e.target as { value: { value: number } }).value?.value || 0;
    updatedData.assetName = "";
  
    setFormData(updatedData as faultTypes);
  
    // ✅ Ensure `getAssetNameList` doesn't require an argument
    getAssetNameList((e.target as { value: { value: number } }).value?.value || 0)
  };

  const handleSelectCountryChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof CountryMaster,
    name2: keyof CountryMaster
  ) => {
    const updatedData: Partial<faultTypes> = { ...formData }; // Ensure all required fields are included
  
    updatedData[name] = (e.target as { value: { label: string } }).value?.label || "";
    updatedData[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    // Reset dependent fields when country changes
    updatedData["regionId"] = 0;
    updatedData["regionName"] = "";
    updatedData["projectId"] = 0;
    updatedData["projectName"] = "";

  
    setFormData(updatedData as faultTypes);
    getRegionList((e.target as { value: { value: number } }).value?.value || 0);  
  };

   const handleSelectRegionChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof RegionMaster,
      name2: keyof RegionMaster
    ) => {
      const updatedData: Partial<faultTypes> = { ...formData};
    
      (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
      (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    
      setFormData(updatedData as faultTypes);
      getProjectList((e.target as { value: { value: number } }).value?.value || 0);  
};
    

  const handleSelectAssetNameChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof assetType,
    name2: keyof assetType
  ) => {
    const updatedData: Partial<faultTypes> = { ...formData }; // Ensure all required fields are included
  
    updatedData[name] = (e.target as { value: { label: string } }).value?.label || "";
    updatedData[name2] = (e.target as { value: { value: number } }).value?.value || 0;
  
    setFormData(updatedData as faultTypes);
  };

  const handleSelectProjectChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof ProjectMaster,
    name2: keyof ProjectMaster
  ) => {
    const updatedData: Partial<faultTypes> = { ...formData};
  
    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;   
  
    setFormData(updatedData as faultTypes);     
    
    
};

  interface Location {
    latitude: number;
    longitude: number;
  }

  const removeFile = (index: number) => {
    const updatedAttachments = [...formData.attachments];
    updatedAttachments.splice(index, 1);
    setFormData({ ...formData, attachments: updatedAttachments });
  };
  
  interface TakeCameraProps {
    formData: faultTypes; // Form data structure
    setFormData: React.Dispatch<React.SetStateAction<faultTypes>>; // Function to set form data
}

const TakeCamera: React.FC<TakeCameraProps> = ({ formData, setFormData }) => {
    const [location, setLocation] = useState<Location | null>(null);
    const [imgsrc, setImgSrc] = useState<string|null>(null);
    const [cameraOpen, setCameraOpen] = useState(false);
    const [openCam,setOpenCam] = useState(false)
    const streamRef = useRef<MediaStream | null>(null);

    useEffect(() => {
        getLocation();
    }, []);

    const watermark = new Image();
      watermark.crossOrigin = "anonymous";
      watermark.src = Logo;
      watermark.onload = function () {
          const canvas = document.createElement("canvas"); 
          canvas.width = watermark.width; 
          canvas.height = watermark.height; 
          const ctx = canvas.getContext("2d");
          if(ctx){
            ctx.drawImage(watermark, 0, 0);
          }
          const imgData = canvas?.toDataURL("image/png"); 
      };
      watermark.onerror = function () {
          console.error("Failed to load watermark image.");
      };

    interface CapturePhotoProps {
      dataUri: string;
    }

    const capturePhoto = async ({ dataUri }: CapturePhotoProps): Promise<void> => {
      try {
        const img = new Image();

        const loadImage = new Promise<void>((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () => reject(new Error("Failed to load image"));
          img.src = dataUri;
        });

        await loadImage;

        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext("2d");

        if (context) {
          context.drawImage(img, 0, 0);

          const timestamp = new Date().toLocaleString();
          const gpsLocation = `${location?.latitude},${location?.longitude}`;

          context.font = "18px Arial";
          context.fillStyle = "white";
          context.fillText(timestamp, 10, 30);
          context.fillText(gpsLocation, 10, 60);

          const logoWidth = 130; // Adjust the logo size as needed
          const logoHeight = 70;
          const logoX = canvas.width - logoWidth - 25; // Adjust the position as needed
          const logoY = canvas.height - logoHeight - 25;
          context.drawImage(watermark, logoX, logoY, logoWidth, logoHeight);
        }
          const photo = canvas.toDataURL();
          setCameraOpen(false);
          setImgSrc(photo);
      } catch (error:any) {
        CustomMessage(`Error capturing photo:${error?.message}`,"error",enqueueSnackbar)
        console.error("Error capturing photo:", error);
      }
    };

    const handleLocation = (position: GeolocationPosition) => {
        setLocation(position.coords);
    };

    const requestCameraAccess = async (video:boolean) => {
      try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: video });
          // Use the camera stream as needed
          streamRef.current = stream; // Store the stream reference
      } catch (error:any) {
        console.error("Error accessing camera:", error);
        CustomMessage(`Error accessing camera:${error?.message}`,'error',enqueueSnackbar);
        const tracks = streamRef.current?.getTracks() || [];
        tracks.forEach((track) => track.stop());
      }
    };

    const stopCamera = () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop()); // Stop all tracks
        streamRef.current = null; // Clear the reference
      }
      setCameraOpen(false);
      setOpenCam(false);
    };            

    const handleError = (error:any) => {
      //CustomMessage(error?.message,'error',enqueueSnackbar);
        console.error(error);
    };

    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(handleLocation, handleError);
        } else {
          CustomMessage("Geolocation is not supported by this browser",'error',enqueueSnackbar);
            console.error("Geolocation is not supported by this browser");
        }
    };

    const openCamera = async () => {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true })
          .then(() => {
            try{
                  requestCameraAccess(true);
                setCameraOpen(true);
                setOpenCam(true);
                // setImgSrc(null);
            }catch(error){
                console.error("Error opening camera:", error);
                setCameraOpen(false);
                setOpenCam(false);
            }
          })
          .catch((error:any) => {
          // Handle camera access error
            CustomMessage(`Camera access denied:${error?.message}`,'error',enqueueSnackbar);
              console.error('Camera access denied:', error);
          });
      }
    };

    const uploadImage = async() => {
      if(!imgsrc){
        CustomMessage("Image not generated",'error',enqueueSnackbar);
        return;
      }
      dispatch(setLoading(true));
      try{
        const file =  base64ToFile({ base64: imgsrc, filename: 'Stock.png' });

        const data = new FormData();
        data.append('file', file); // Ensure the key matches backend expectations       

        const response = await uploadFiles(data);
        if (response.status.code === 201) {
          const updatedFormData = { ...formData };
          updatedFormData.attachments = [...updatedFormData.attachments, response.data];
          setFormData(updatedFormData);

          stopCamera();
        } else {
          CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
        }
      }catch(error:any){
        CustomMessage(error?.message,'error',enqueueSnackbar);
      }finally{
        dispatch(setLoading(false));
      }
    }

    return (
      <div>
        <ReusablePrimeReactDialog
          header="Take Photo"
          visible={openCam}
          onHide={stopCamera}
          footer={
            <div>
              {!cameraOpen&&
                <>
                  <ReusablePrimeButton severity="secondary" onClick={stopCamera}>Cancel</ReusablePrimeButton>
                  <ReusablePrimeButton severity="info" onClick={uploadImage}>Upload</ReusablePrimeButton>
                </>
              }
            </div>
          }
        >
          {
            cameraOpen ?
                <Camera
                    onTakePhoto={(dataUri: string) => capturePhoto({ dataUri })}
                    idealFacingMode="environment"
                    isFullscreen={false}
                    idealResolution={{ width: 640, height: 480 }}
                    imageType={IMAGE_TYPES.PNG}
                    videoStream={streamRef.current}
                />
            :
            imgsrc && <img src={imgsrc} alt="logo" />
          }
            </ReusablePrimeReactDialog>
            <Box display="flex" flexDirection="column" alignItems="center">   
              <Box
                onClick={openCamera}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: 2,
                  border: "1px dashed gray",
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "300px",
                  textAlign: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFFFFF",
                  maxHeight: "45px",  
                }}
              >
                <ChooseCam />
                <span>Take photo</span>
              </Box>            
              <ListItem>
                {formData.attachments.map((attachment, index) => (
                  <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    
                      <Box display="flex" flexDirection="row" gap={1}>
                      </Box>
                  </div>
                  ))}
              </ListItem>
            </Box>
      </div>
      );
    };


return (
  
  <div>    
    <Box display="flex" alignItems="center" justifyContent="left" width="100%" position="relative">
      <Typography variant="h4" style={styles.heading}>Create Fault</Typography>
      <IconButton onClick={handleReset} style={{ position: "absolute", right: 0, color: "#004489" }}>
        <RefreshIcon />
      </IconButton>
    </Box>
    <div style={styles.container}>
      <form>
        <Grid container spacing={5} rowSpacing={3} columnSpacing={2} style={{ width: "100%" }}>
          {/* Asset Type */}
          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Asset Type</label>
            <Autocomplete
              options={familyAssetName}
              getOptionLabel={(option) => option.label || ""}
              value={familyAssetName.find(opt => opt.value === formData.familyAssetId) || null}
              onChange={(_event, newValue) => {
                handleSelectAssetTypeChange(
                  { target: { value: newValue || null } },
                  "familyName",
                  "familyAssetId"
                );
              }}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select an Asset Type"
                  variant="outlined"
                  style={{ background: "#fff", borderRadius: 5 }}
                />
              )}
            />
          </Grid>

          {/* Asset Name */}
          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Asset Name</label>
            <Autocomplete
              fullWidth
              options={assetName}
              getOptionLabel={(option) => option.label || ""}
              value={assetName.find(opt => opt.value === formData.assetName) || null}
              onChange={(_event, newValue) => {
                handleSelectAssetNameChange(
                  { target: { value: newValue || null } },
                  "assetName",
                  "assetName"
                );
              }}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select an Asset Name"
                  variant="outlined"
                  style={{ background: "#fff", borderRadius: 5 }}
                />
              )}
            />

          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Current Location</label>
            <Autocomplete
              fullWidth
              options={countryName}
              getOptionLabel={(option) => option.label || ""}
              value={countryName.find(opt => opt.value === formData.currentLocationId) || null}
              onChange={(_event, newValue) => {
                handleSelectCountryChange(
                  { target: { value: newValue || null } },
                  "countryName",
                  "currentLocationId"
                );
              }}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Current Location"
                  variant="outlined"
                  style={{ background: "#fff", borderRadius: 5 }}
                />
              )}
            />
          </Grid>

           <Grid item xs={12} sm={6} md={3}>
              <label style={styles.label}>Region</label>
              <Autocomplete
                fullWidth
                options={region}
                getOptionLabel={(option) => option.label || ""}
                value={region.find(opt => opt.value === formData.regionId) || null}
                onChange={(_event, newValue) => {
                  handleSelectRegionChange(
                    { target: { value: newValue || null } },
                    "regionName",
                    "regionId"
                  );
                }}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select a Region"
                    variant="outlined"
                    style={{ background: "#fff", borderRadius: 5 }}
                  />
                )}
              />
           </Grid>
           <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Project</label>
            <Autocomplete
            fullWidth
            options={project}
            getOptionLabel={(option) => option.label || ""}
            value={project.find(opt => opt.value === formData.projectId) || null}
            onChange={(_event, newValue) => {
              handleSelectProjectChange(
                { target: { value: newValue || null } },
                "projectName",
                "projectId"
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select a Project"
                variant="outlined"
                style={{ background: "#fff", borderRadius: 5 }}
              />
            )}
            />
           </Grid>

          {/* Hour Meter */}
          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Hour Meter</label>
            <TextField
              fullWidth
              type="number"
              value={formData.hourMeter}
              className="bg-white"
              onChange={(e) => setFormData({ ...formData, hourMeter: parseInt(e.target.value, 10) })}
            />
          </Grid>

          {/* Fault Description */}
          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Fault Description</label>
            <TextField
              fullWidth
              value={formData.fault}
              className="bg-white"
              onChange={(e) => setFormData({ ...formData, fault: e.target.value })}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Date</label>
            <Calendar
              id="date"
              className="w-100 block bg-white h-45"
              value={formData.date ? new Date(formData.date) : null}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  date: e.value ? dayjs(e.value).format("YYYY-MM-DD") : "",
                })
              }
              showIcon
              dateFormat="mm/dd/yy"
              placeholder="Select Date"
            />
          </Grid>

          {/* Attach File */}
          <Grid item xs={12} sm={6} md={3}>
            <label style={styles.label}>Attach File</label>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="fileUpload"></InputLabel>
              <Input
                id="fileUpload"
                type="file"
                inputProps={{ multiple: true, accept: ".pdf, .xls, .xlsx" }}
                onChange={handleFileUpload}
                className="bg-white m-0 h-45 border border-[#0000003b]"
              />
            </FormControl>
          </Grid>

          {/* Camera Capture Button */}
          <Grid item xs={12} sm={6} md={3}>
          <label style={styles.label}>Take Photo</label>
          <div style={{ border: "0px" }}></div>
            <TakeCamera formData={formData} setFormData={setFormData} />
          </Grid>

          

          {/* Display Uploaded Attachments Only If Present */}
        {formData?.attachments?.length > 0 && (
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: "5px",
                p: 1,
                backgroundColor: "#f9f9f9",
              }}
            >
              <List sx={{ width: "100%", bgcolor: "background.paper", px: 1 }}>
                {formData.attachments.map((file, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #ddd",
                      p: 0,
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" sx={{ wordBreak: "break-word", flexGrow: 1 }}>
                      {file.name}
                    </Typography>
                    <IconButton
                      onClick={() => {
                        const fileUrl = `${FILE_DOWNLOAD_PREVIEW + file.attachmentId}`;
                        const link = document.createElement("a");
                        link.href = fileUrl;
                        link.setAttribute("download", "");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                    >
                      <DownloadIcon color="primary" />
                    </IconButton>
                    <IconButton onClick={() => removeFile(index)}>
                      <CloseIcon color="error" />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        )}

          {/* Submit Button */}
          <Grid item xs={12} display="flex" justifyContent="right">
            {userDetails.role.some(
              (r) => r.roleName === "Admin" || r.roleName === "Report Fault Write"
            ) && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            )}
          </Grid>

        </Grid>
        </form>
    </div>
  </div>
  
  )  
  };
  

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: "",
    width: "",
    margin: "",
    padding: "15px",
    border: "1px solid #eee",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    textAlign: "left",
    color: "#333",
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  formGroup: {
    marginBottom: "10px",
    width: "100%",
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    display: "block",
    marginBottom: "3px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};

export default CreateFault;

